import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'common/modal';
import Button from 'common/button';

const TimeoutMessage = ({ show, onClose }) => (
    <Modal close={onClose} isOpen={show}>
        <div className="p-14 text-center">
            <h1 className="text-21 text-gray-80 font-black leading-snug">
                Your contribution is taking unusually long to process.
            </h1>
            <p className="text-16 text-gray-60 leading-relaxed mt-4">
                Keep an eye on your email. You should receive confirmation of your contribution
                shortly.
            </p>

            <div className="-mb-4 mt-8">
                <Button
                    color="green"
                    size="md"
                    className="text-16 font-medium block w-full"
                    onClick={onClose}
                    data-testid="close"
                >
                    Back to Campaign
                </Button>
            </div>
        </div>
    </Modal>
);

TimeoutMessage.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default TimeoutMessage;
